<template>
  <v-card flat height="100%">
    <v-card-title>
      <v-layout>
        <v-flex xs8 ma-2>Ärzte</v-flex>
        <v-spacer></v-spacer>
        <v-flex xs2 ma-2>
          <v-btn
            block
            color="primary"
            @click="back"
            :disabled="edited.namensdaten.vorname!=='' || edited.namensdaten.nachname!==''"
          >Zurück</v-btn>
        </v-flex>
        <v-flex xs2 ma-2>
          <v-btn
            block
            color="primary"
            @click="forward"
            :disabled="edited.namensdaten.vorname!=='' || edited.namensdaten.nachname!==''"
          >Weiter</v-btn>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <v-layout wrap>
        <v-flex xs12 md12 lg6 pa-1>
          <v-data-table
            :headers="headers"
            :items="aerzte"
            :sort-by="['namensdaten.nachname']"
            :sort-desc="[false]"
            disable-pagination
            hide-default-footer
          >
            <template v-slot:item.status="{ item }">
              <v-icon v-if="item.hasValidationErrors" color="red">mdi-alert-circle</v-icon>
              <v-icon v-if="!item.hasValidationErrors" color="green">mdi-checkbox-marked-circle</v-icon>
            </template>
            <template v-slot:item.namensdaten="{ item }">{{name(item)}}</template>
            <template v-slot:item.praxisinhaber="{ item }">
              <div v-if="item.praxisinhaber">ja</div>
            </template>
            <template v-slot:item.gueltig="{ item }">
              <v-chip>{{gueltig(item)}}</v-chip>
            </template>
            <template v-slot:item.hzv="{ item }">
              <v-chip v-if="hzv(item)!==''">{{hzv(item)}}</v-chip>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon class="pa-1" @click="edit(item)">mdi-pencil</v-icon>
              <v-icon class="pa-1" @click="remove(item)" v-if="!item.lizenzaenderung">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 md12 lg6 pa-1>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout wrap>
              <v-flex xs12 sm6 md2 pa-1>
                <v-select v-model="edited.namensdaten.anrede" :items="anreden" label="Anrede"></v-select>
              </v-flex>
              <v-flex xs12 sm6 md3 pa-1>
                <v-text-field v-model="edited.namensdaten.titel" label="Titel"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3 pa-1>
                <v-text-field
                  v-model="edited.namensdaten.vorname"
                  label="Vorname"
                  :rules="rules.vorname"
                  :counter="64"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                <v-text-field
                  v-model="edited.namensdaten.nachname"
                  label="Nachname"
                  :rules="rules.nachname"
                  :counter="64"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm6 md6 pa-1>
                <v-menu
                  v-model="aktivAb"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="!aktivAbEnabled"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="edited.aktivAb"
                      readonly
                      label="Aktiv-Ab"
                      v-on="on"
                      :rules="rules.aktivAb"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="edited.aktivAb" type="month" @input="aktivAb = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-1>
                <v-menu
                  v-model="aktivBis"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="!aktivBisEnabled"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="edited.aktivBis"
                      readonly
                      label="Aktiv-Bis"
                      v-on="on"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="edited.aktivBis" @input="aktivBis = false"></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm6 md6 pa-1>
                <v-menu
                  v-model="hzvAb"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="edited.hzvAb"
                      readonly
                      label="HZV-Ab"
                      v-on="on"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="edited.hzvAb" type="month" @input="hzvAb = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-1>
                <v-menu
                  v-model="hzvBis"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="edited.hzvBis"
                      readonly
                      label="HZV-Bis (Ende des ausgewählten Monats)"
                      v-on="on"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="edited.hzvBis" type="month" @input="hzvBis = false"></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex
                xs12
                sm6
                md4
                pa-1
                v-if="edited.inaktivChangeAllowed=== undefined || edited.inaktivChangeAllowed===true"
              >
                <v-checkbox v-model="edited.inaktiv" label="Inaktiv (nur für Konvertierung)" :disabled="!inaktivEnabled"></v-checkbox>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                <v-checkbox
                  v-model="edited.datenuebernahmeAusKonvertierung"
                  label="Datenübernahme aus Vorprogramm"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                <v-checkbox v-model="edited.praxisinhaber" label="Praxisinhaber/in"></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm6 md6 pa-1>
                <v-checkbox v-model="edited.updateVerteiler" label="Updateverteiler"></v-checkbox>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-1 v-if="license.lizenzaenderung">
                <v-checkbox
                  v-model="edited.weiternutzung"
                  label="Lizenzweiternutzung"
                  hint="Sollte eine Arztlizenz an einen anderen Nutzer übergeben werden, setzten Sie hier das Kreuz. Dafür muss eine nicht mehr genutzte Arztlizenz vorhanden sein."
                  persistent-hint
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm6 md6 pa-1 v-if="!edited.inaktiv && !edited.weiternutzung">
                <v-text-field
                  v-model="edited.verkaufsPreis"
                  label="Verkaufspreis Arzt"
                  :rules="rules.preis"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-1>
                <v-text-field
                  v-model="edited.primaereEmailAdresse.email"
                  label="Primäre Email-Adresse"
                  :rules="rules.email"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="arztrollenHeaders"
              :items="edited.arztrollen"
              :sort-by="['lanr']"
              :sort-desc="[false]"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:item.behandlungsorte="{ item }">
                <v-list-item
                  v-for="behandlungsort in item.behandlungsorte"
                  :key="behandlungsort.id"
                >
                  {{behandlungsort.name}}
                  <v-chip small class="ma-2">{{gueltigBehandlungsort(behandlungsort)}}</v-chip>
                  <v-chip small class="ma-2">{{behandlungsort.bsnr}}</v-chip>
                </v-list-item>
              </template>
              <template v-slot:item.action="{ item }">
                <v-icon class="pa-1" @click="editRolle(item)">mdi-pencil</v-icon>
                <v-icon
                  class="pa-1"
                  @click="removeRolle(item)"
                  v-if="!item.lizenzaenderung"
                >mdi-delete</v-icon>
              </template>
            </v-data-table>
            <v-dialog v-model="arztrolleDialog" max-width="60rem">
              <v-card>
                <v-card-title class="headline">Arztrolle</v-card-title>
                <v-card-text>
                  <v-form ref="rolleForm" v-model="validRolle" lazy-validation>
                    <v-layout wrap>
                      <div
                        v-if="edited.lizenzaenderung"
                        class="red--text text-justify"
                      >Eine LANR darf nur geändert werden, wenn diese vorher falsch hinterlegt war. Wenn der Arzt eine neue LANR bekommen hat, muss eine weitere Arztrolle angelegt werden. Soll die alte LANR nicht mehr verwendet werden, muss die Zuordnung zum Behandlungsort entfernt werden.</div>
                      <v-flex xs12 sm6 md4 pa-1>
                        <v-text-field
                          v-model="editedRolle.lanr"
                          label="LANR"
                          :rules="rules.lanr"
                          :counter="9"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4 pa-1>
                        <v-text-field
                          v-model="editedRolle.kuerzel"
                          label="Kürzel"
                          :rules="rules.kuerzel"
                          :counter="5"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4 pa-1>
                        <v-checkbox
                          v-model="editedRolle.knappschaftsarzt"
                          label="Ist Knappschaftsarzt"
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md12 pa-1>
                        <v-data-table
                          v-model="editedRolle.behandlungsorte"
                          :headers="arztrolleBehandlungsortHeaders"
                          :items="license.behandlungsorte"
                          :single-select="false"
                          item-key="id"
                          show-select
                        >
                          <template v-slot:item.name="{ item }">
                            {{item.name}}
                            <v-chip small class="ma-2">{{gueltigBehandlungsort(item)}}</v-chip>
                            <v-chip small class="ma-2">{{item.bsnr}}</v-chip>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeArztrolleDialog">Abbrechen</v-btn>
                  <v-btn color="blue darken-1" text @click="saveRolle">Speichern</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-layout wrap>
              <v-flex xs12 sm12 md12 pa-1>
                <v-btn
                  block
                  color="primary"
                  @click="arztrolleDialog = true"
                >Arztrolle (LANR) hinzufügen</v-btn>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="asvrollenHeaders"
              :items="asvrollen"
              disable-pagination
              hide-default-footer
              v-if="asvTeamsAktiv"
            >
              <template v-slot:item.asvTeam="{item}">{{item.asvTeam.name}}</template>
              <template v-slot:item.arztrolle="{item}">{{item.arztrolle.lanr}}</template>
              <template v-slot:item.action="{ item }">
                <v-icon class="pa-1" @click="editAsvrolle(item)">mdi-pencil</v-icon>
                <v-icon
                  class="pa-1"
                  @click="removeAsvrolle(item)"
                  v-if="!item.lizenzaenderung"
                >mdi-delete</v-icon>
              </template>
            </v-data-table>
            <v-dialog v-model="asvrolleDialog" max-width="60rem">
              <v-card>
                <v-card-title class="headline">ASV-Rolle</v-card-title>
                <v-card-text>
                  <v-form ref="asvrolleform" v-model="validRolle" lazy-validation>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md412 pa-1>
                        <v-text-field
                          v-model="editedAsvrolle.kuerzel"
                          label="Kürzel"
                          :rules="rules.asvkuerzel"
                          :counter="5"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md6 pa-1>
                        <v-select
                          v-model="editedAsvrolle.asvTeam"
                          :items="license.asvTeams"
                          label="ASV-Team"
                          chips
                          item-text="name"
                          return-object
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 md6 pa-1>
                        <v-select
                          v-model="editedAsvrolle.arztrolle"
                          :items="edited.arztrollen"
                          label="Arztrolle"
                          chips
                          item-text="lanr"
                          return-object
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeAsvrolleDialog">Abbrechen</v-btn>
                  <v-btn color="blue darken-1" text @click="saveAsvrolle">Speichern</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-layout wrap v-if="asvTeamsAktiv">
              <v-flex xs12 sm12 md12 pa-1>
                <v-btn block color="primary" @click="asvrolleDialog = true">ASV-Rolle hinzufügen</v-btn>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-spacer></v-spacer>
              <v-btn class="ma-2" color="error" @click="clear">Bearbeitung abbrechen</v-btn>
              <v-btn class="ma-2" color="primary" @click="save">Speichern</v-btn>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-dialog v-model="deleteArztDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Wollen Sie diesen Eintrag wirklich löschen?</v-card-title>
        <v-card-text>Das Löschen kann nicht wieder rückgängig gemacht werden</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteArztDialog = false">Abbrechen</v-btn>
          <v-btn color="blue darken-1" text @click="deleteArzt">Löschen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteArztrolleDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Wollen Sie diesen Eintrag wirklich löschen?</v-card-title>
        <v-card-text>Das Löschen kann nicht wieder rückgängig gemacht werden. Denken Sie daran die Änderungen noch am Arzt zu speichern.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteArztrolleDialog = false">Abbrechen</v-btn>
          <v-btn color="blue darken-1" text @click="deleteArztrolle">Löschen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteAsvrolleDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Wollen Sie diesen Eintrag wirklich löschen?</v-card-title>
        <v-card-text>Das Löschen kann nicht wieder rückgängig gemacht werden. Denken Sie daran die Änderungen noch am Arzt zu speichern.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteAsvrolleDialog = false">Abbrechen</v-btn>
          <v-btn color="blue darken-1" text @click="deleteAsvrolle">Löschen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import { mapState } from "vuex";
const dateFormat = { month: "2-digit", year: "numeric" };
function trimObjectValues(obj) {
  if (obj !== undefined && obj !== null) {
    Object.keys(obj).map(k => {
      var value = obj[k];
      if (value !== undefined && value !== null && typeof value == "string") {
        obj[k] = value.trim();
      } else if (value !== undefined && value !== null) {
        trimObjectValues(value);
      }
    });
  }
}
function edited() {
  return {
    aktivAb: null,
    aktivBis: null,
    datenuebernahmeAusKonvertierung: true,
    hzvAb: null,
    hzvBis: null,
    inaktiv: false,
    arztrollen: [],
    namensdaten: {
      anrede: null,
      nachname: "",
      titel: "",
      vorname: ""
    },
    praxisinhaber: "",
    primaereEmailAdresse: {
      email: ""
    },
    updateVerteiler: false,
    weiternutzung: false,
    lizenzaenderung: false
  };
}
function editRolle() {
  return {
    lanr: "",
    kuerzel: "",
    knappschaftsarzt: false,
    behandlungsorte: [],
    asvRollen: []
  };
}
function editAsvrolle() {
  return {
    asvTeam: {},
    kuerzel: ""
  };
}
export default {
  data() {
    return {
      valid: false,
      validRolle: false,
      aktivAb: false,
      aktivAbEnabled: true,
      aktivBis: false,
      aktivBisEnabled: true,
      inaktivEnabled: true,
      hzvAb: false,
      hzvBis: false,
      arztrolleDialog: false,
      asvrolleDialog: false,
      arztrolleIndex: -1,
      asvrolleIndex: -1,
      arztrolleBehandlungsortHeaders: [
        { text: "Behandlungsort", value: "name" }
      ],
      headers: [
        { text: "", value: "status", sortable: false },
        { text: "Vorname", value: "namensdaten.vorname" },
        { text: "Nachname", value: "namensdaten.nachname" },
        { text: "Gültig", value: "gueltig" },
        { text: "HZV", value: "hzv" },
        { text: "Praxisinhaber", value: "praxisinhaber" },
        { text: "Aktionen", value: "action", sortable: false }
      ],
      arztrollenHeaders: [
        { text: "LANR", value: "lanr" },
        { text: "Kürzel", value: "kuerzel" },
        { text: "Behandlungsorte", value: "behandlungsorte", sortable: false },
        { text: "Aktionen", value: "action", sortable: false }
      ],
      asvrollenHeaders: [
        { text: "Arztrolle", value: "arztrolle" },
        { text: "ASV-Team", value: "asvTeam" },
        { text: "Kürzel", value: "kuerzel" },
        { text: "Aktionen", value: "action", sortable: false }
      ],
      edited: edited(),
      editedRolle: editRolle(),
      editedAsvrolle: editAsvrolle(),
      deleteArztDialog: false,
      deleteArztItem: null,
      deleteArztrolleDialog: false,
      deleteArztrolleItem: null,
      deleteAsvrolleDialog: false,
      deleteAsvrolleItem: null,
      rules: {
        aktivAb: [
          v =>
            (this.license.lizenzaenderung &&
            !this.edited.inaktiv &&
            !this.edited.lizenzaenderung
              ? !!v && v !== ""
              : true) || "Aktiv-Ab muss gefüllt werden"
        ],
        vorname: [
          v => !!v || "Der Vorname darf nicht leer sein",
          v => v.length <= 64 || "Der Vorname muss kürzer als 64 Zeichen sein"
        ],
        nachname: [
          v => !!v || "Der Nachname darf nicht leer sein",
          v => v.length <= 64 || "Der Nachname muss kürzer als 64 Zeichen sein"
        ],
        email: [
          v =>
            (this.edited.updateVerteiler ? !!v : true) ||
            "Die Primäre Email-Adresse darf nicht leer sein",
          v =>
            v === null
              ? true
              : v.length <= 255 ||
                "Die Primäre Email-Adresse muss kürzer als 255 Zeichen sein",
          v =>
            v === null
              ? true
              : (v.length === 0 ? true : /.+@.+\..+/.test(v)) ||
                "Die Primäre Email-Adresse ist ungültig"
        ],
        kuerzel: [
          v => !!v || "Das Kürzel darf nicht leer sein",
          v => v.length <= 5 || "Das Kürzel muss kürzer als 5 Zeichen sein",
          v =>
            this.edited.arztrollen.findIndex(
              rolle => rolle.kuerzel === v && rolle.id !== this.editedRolle.id
            ) <= -1 || "Das Kürzel muss eindeutig sein"
        ],
        lanr: [
          v =>
            v.length === 0
              ? true
              : v.length === 9 || "Die LANR muss 9 Ziffern lang sein",
          v =>
            v.length === 0
              ? true
              : new RegExp("^[0-9]+$").test(v) ||
                "Die LANR darf nur Ziffern enthalten",
          v =>
            this.edited.arztrollen.findIndex(
              rolle => rolle.lanr === v && rolle.id !== this.editedRolle.id
            ) <= -1 || "Die LANR muss eindeutig sein"
        ],
        preis: [
          v =>
            v === undefined || v === null
              ? true
              : (v.length === 0 ? true : !isNaN(v)) ||
                "Der Preis darf keine Leerzeichen oder Buchstaben entahlten"
        ],
        asvkuerzel: [
          v => !!v || "Das Kürzel darf nicht leer sein",
          v => v.length <= 5 || "Das Kürzel muss kürzer als 5 Zeichen sein",
          v =>
            this.asvrollen.findIndex(
              rolle =>
                rolle.kuerzel === v && rolle.id !== this.editedAsvrolle.id
            ) <= -1 || "Das Kürzel muss eindeutig sein"
        ]
      }
    };
  },
  computed: {
    ...mapState({
      aerzte: state => state.current.bestellung.lizenz.aerzte,
      process: state => state.current.process,
      license: state => state.current.bestellung.lizenz,
      anreden: state => state.anreden,
      asvTeamsAktiv: state => state.current.bestellung.asvTeamsAktiv,
      savedPrice: state => state.current.prices.arzt
    }),
    asvrollen: function() {
      const rollen = [];
      this.edited.arztrollen.forEach(rolle => {
        rolle.asvRollen.forEach(asvrolle => {
          asvrolle.arztrolle = rolle;
          rollen.push(asvrolle);
        });
      });
      return rollen;
    }
  },
  mounted: function() {
    if (
      this.$route.params.process != this.process ||
      this.license === undefined
    ) {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.BestellungRequestEvent",
        processId: this.$route.params.process,
        taskId: this.$route.params.task
      });
    }
    this.edited.verkaufsPreis = this.savedPrice;
    this.edited.datenuebernahmeAusKonvertierung = !this.license.lizenzaenderung;
  },
  watch: {
    "edited.inaktiv": function(nV, oV) {
      if (oV === false && nV === true && this.edited.verkaufsPreis === 0) {
        this.edited.verkaufsPreis = this.savedPrice;
      }
      if (nV === true) {
        this.aktivAbEnabled = false;
        this.aktivBisEnabled = false;
      } else {
        this.aktivAbEnabled = true;
        this.aktivBisEnabled = true;
      }
    },
    "edited.aktivAb": function (nV) {
      if ((nV !== undefined && nV !== null && nV !== "")  || (this.edited.aktivBis !== undefined && this.edited.aktivBis !== null && this.edited.aktivBis !== "")) {
        this.inaktivEnabled = false;
      } else {
        this.inaktivEnabled = true;
      }
    },
    "edited.aktivBis": function (nV) {
      if ((nV !== undefined && nV !== null && nV !== "" )|| (this.edited.aktivAb !== undefined && this.edited.aktivAb !== null && this.edited.aktivAb !== "")) {
        this.inaktivEnabled = false;
      } else {
        this.inaktivEnabled = true;
      }
    },
    aerzte: function(nV, oV) {
      if (nV !== undefined && nV.length >= oV.length) {
        this.clear();
      }
    },
    license: function(nV) {
      if (nV !== undefined) {
        this.edited.datenuebernahmeAusKonvertierung = !this.license
          .lizenzaenderung;
      }
    }
  },
  methods: {
    editAsvrolle: function(asvrolle) {
      const arztrolle = this.edited.arztrollen.find(
        rolle => rolle === asvrolle.arztrolle
      );
      this.asvrolleIndex = arztrolle.asvRollen.findIndex(
        rolle => rolle.id === asvrolle.id && rolle.kuerzel === asvrolle.kuerzel
      );
      this.editedAsvrolle = Object.assign({}, asvrolle);
      this.asvrolleDialog = true;
    },
    editRolle: function(rolle) {
      const asvRollen = rolle.asvRollen;
      rolle.asvRollen = [];
      this.editedRolle = JSON.parse(JSON.stringify(rolle));
      this.arztrolleIndex = this.edited.arztrollen.indexOf(rolle);
      this.arztrolleDialog = true;
      rolle.asvRollen = asvRollen;
    },
    edit: function(editArzt) {
      const arzt = JSON.parse(JSON.stringify(editArzt));
      if (arzt.aktivAb !== null) {
        arzt.aktivAb = arzt.aktivAb.substr(0, 7);
      }
      if (arzt.hzvAb !== null) {
        arzt.hzvAb = arzt.hzvAb.substr(0, 7);
      }
      if (arzt.hzvBis !== null) {
        arzt.hzvBis = arzt.hzvBis.substr(0, 7);
      }
      this.edited = arzt;
      this.$refs.form.resetValidation();
      this.$vuetify.goTo(0);
    },
    gueltig: function(arzt) {
      if (arzt.inaktiv) {
        return "inaktiv";
      } else {
        if (arzt.aktivAb === null && arzt.aktivBis === null) {
          return "aktiv";
        } else if (arzt.aktivAb !== null && arzt.aktivBis === null) {
          return (
            new Date(arzt.aktivAb).toLocaleDateString(undefined, dateFormat) +
            " - n. a."
          );
        } else if (arzt.aktivAb === null && arzt.aktivBis !== null) {
          return (
            "n. a. - " +
            new Date(arzt.aktivBis).toLocaleDateString(undefined, dateFormat)
          );
        } else {
          return (
            new Date(arzt.aktivAb).toLocaleDateString(undefined, dateFormat) +
            " - " +
            new Date(arzt.aktivBis).toLocaleDateString(undefined, dateFormat)
          );
        }
      }
    },
    gueltigBehandlungsort: function(behandlungsort) {
      if (behandlungsort.inaktiv) {
        return "inaktiv";
      } else {
        const monthDateFormat = { month: "2-digit", year: "numeric" };
        const dateFormat = {
          day: "2-digit",
          month: "2-digit",
          year: "numeric"
        };
        if (
          behandlungsort.aktivAb === null &&
          behandlungsort.aktivBis === null
        ) {
          return "aktiv";
        } else if (
          behandlungsort.aktivAb !== null &&
          behandlungsort.aktivBis === null
        ) {
          return (
            new Date(behandlungsort.aktivAb).toLocaleDateString(
              undefined,
              monthDateFormat
            ) + " - n. a."
          );
        } else if (
          behandlungsort.aktivAb === null &&
          behandlungsort.aktivBis !== null
        ) {
          return (
            "n. a. - " +
            new Date(behandlungsort.aktivBis).toLocaleDateString(
              undefined,
              dateFormat
            )
          );
        } else {
          return (
            new Date(behandlungsort.aktivAb).toLocaleDateString(
              undefined,
              monthDateFormat
            ) +
            " - " +
            new Date(behandlungsort.aktivBis).toLocaleDateString(
              undefined,
              monthDateFormat
            )
          );
        }
      }
    },
    name: function(arzt) {
      return arzt.namensdaten.vorname + " " + arzt.namensdaten.nachname;
    },
    behandlungsortName: function(behandlungsort) {
      return (
        behandlungsort.name +
        " (" +
        (behandlungsort.inaktiv ? "Inaktiv" : "Aktiv") +
        ")"
      );
    },
    hzv: function(arzt) {
      if (arzt.hzvAb === null && arzt.hzvBis === null) {
        return "";
      } else if (arzt.hzvAb !== null && arzt.hzvBis === null) {
        return (
          new Date(arzt.hzvAb).toLocaleDateString(undefined, dateFormat) +
          " - n. a."
        );
      } else if (arzt.hzvAb === null && arzt.hzvBis !== null) {
        return (
          "n. a. - " +
          new Date(arzt.hzvBis).toLocaleDateString(undefined, dateFormat)
        );
      } else {
        return (
          new Date(arzt.hzvAb).toLocaleDateString(undefined, dateFormat) +
          " - " +
          new Date(arzt.hzvBis).toLocaleDateString(undefined, dateFormat)
        );
      }
    },
    clear: function() {
      this.edited = edited();
      this.$refs.form.resetValidation();
      this.edited.verkaufsPreis = this.savedPrice;
      this.edited.datenuebernahmeAusKonvertierung = !this.license
        .lizenzaenderung;
    },
    save: function() {
      if (this.$refs.form.validate()) {
        this.edited.arztrollen.forEach(arztrolle =>
          arztrolle.asvRollen.forEach(asvRolle => {
            asvRolle.arztrolle = {};
          })
        );
        const arzt = this.edited;
        if (
          arzt.aktivAb !== null &&
          (arzt.aktivAb.match(/-/g) || []).length < 2
        ) {
          arzt.aktivAb += "-01";
        }
        if (arzt.hzvAb !== null && (arzt.hzvAb.match(/-/g) || []).length < 2) {
          arzt.hzvAb += "-01";
        }
        if (
          arzt.hzvBis !== null &&
          (arzt.hzvBis.match(/-/g) || []).length < 2
        ) {
          arzt.hzvBis += "-01";
        }
        trimObjectValues(arzt);
        this.$store.commit("startLoading");
        this.$socket.sendObj({
          eventID:
            "de.t2med.lizenzomat.eventapi.usecase.order.arzt.ArztSaveRequestEvent",
          processId: this.$route.params.process,
          taskId: this.$route.params.task,
          arzt: arzt
        });
      }
    },
    closeArztrolleDialog: function() {
      this.editedRolle = editRolle();
      this.$refs.rolleForm.resetValidation();
      this.arztrolleDialog = false;
      this.arztrolleIndex = -1;
    },
    saveRolle: function() {
      if (this.$refs.rolleForm.validate()) {
        const index =
          this.arztrolleIndex !== -1
            ? this.arztrolleIndex
            : this.edited.arztrollen.findIndex(
                arztrolle =>
                  arztrolle.id === this.editedRolle.id &&
                  arztrolle.lanr === this.editedRolle.lanr
              );
        if (index > -1) {
          this.editedRolle.asvRollen = this.edited.arztrollen[index].asvRollen;
          this.edited.arztrollen.splice(index, 1, this.editedRolle);
        } else {
          this.edited.arztrollen.push(this.editedRolle);
        }
        this.closeArztrolleDialog();
      }
    },
    removeRolle: function(rolle) {
      this.deleteArztrolleItem = rolle;
      this.deleteArztrolleDialog = true;
    },
    deleteArztrolle: function() {
      const index = this.edited.arztrollen.findIndex(
        arztrolle =>
          arztrolle.kuerzel === this.deleteArztrolleItem.kuerzel &&
          arztrolle.id === this.deleteArztrolleItem.id
      );
      if (index > -1) {
        this.edited.arztrollen.splice(index, 1);
      }
      this.deleteArztrolleItem = null;
      this.deleteArztrolleDialog = false;
    },
    closeAsvrolleDialog: function() {
      this.editedAsvrolle = editAsvrolle();
      this.$refs.asvrolleform.resetValidation();
      this.asvrolleDialog = false;
      this.asvrolleIndex = -1;
    },
    saveAsvrolle: function() {
      if (this.$refs.asvrolleform.validate()) {
        const arztrolle = this.edited.arztrollen.find(
          rolle => rolle === this.editedAsvrolle.arztrolle
        );
        if (this.asvrolleIndex > -1) {
          arztrolle.asvRollen.splice(
            this.asvrolleIndex,
            1,
            this.editedAsvrolle
          );
        } else {
          arztrolle.asvRollen.push(this.editedAsvrolle);
        }
        this.closeAsvrolleDialog();
      }
    },
    removeAsvrolle: function(asvrolle) {
      this.deleteAsvrolleItem = asvrolle;
      this.deleteAsvrolleDialog = true;
    },
    deleteAsvrolle: function() {
      const arztrolle = this.edited.arztrollen.find(
        rolle => rolle === this.deleteAsvrolleItem.arztrolle
      );
      const index = arztrolle.asvRollen.indexOf(this.deleteAsvrolleItem);
      if (index > -1) {
        arztrolle.asvRollen.splice(index, 1);
      }
      this.deleteAsvrolleItem = null;
      this.deleteAsvrolleDialog = false;
    },
    remove: function(arzt) {
      this.deleteArztItem = arzt;
      this.deleteArztDialog = true;
    },
    deleteArzt: function() {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.arzt.ArztDeleteRequestEvent",
        arztID: this.deleteArztItem.id
      });
      this.deleteArztItem = null;
      this.deleteArztDialog = false;
    },
    back: function() {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.BackwardRequestEvent",
        taskId: this.$route.params.task,
        processId: this.$route.params.process
      });
    },
    forward: function() {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.arzt.ArztContinueRequestEvent",
        taskId: this.$route.params.task,
        processId: this.$route.params.process
      });
    }
  }
};
</script>
